<template>
  <div class="w-full -mx-3">
    <Card class="w-full mb-6 mx-3">
      <template v-slot:header>
        <span>
          Pending Stream Sales
        </span>
      </template>
      <template v-slot:body>
        <CustomTable class="shadow-md mb-4">
          <template v-slot:header>
            <th
              class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">
              Description
            </th>
            <th
              class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">
              Stream ID
            </th>
            <th
              class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">
              Network
            </th>
            <th
              class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">
              Puchasing User
            </th>
            <th
              class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">
              Expires
            </th>
            <th
              class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">
              Purchase At
            </th>
            <th class="bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"></th>
          </template>
          <template v-slot:body>
            <tr class="hover:bg-grey-lighter" v-for="stream in pendingSales">
              <td class="py-4 px-6 border-b border-grey-light">
                {{ stream.description }}
              </td>
              <td class="py-4 px-6 border-b border-grey-light">
                {{ stream.stream_id }}
              </td>
              <td class="py-4 px-6 border-b border-grey-light">
                {{ stream.network.name }}
              </td>
              <td class="py-4 px-6 border-b border-grey-light">
                {{ stream.purchaser.name }}
              </td>
              <td class="py-4 px-6 border-b border-grey-light">
                {{ stream.expires_at | timeAgo }}
              </td>
              <td class="py-4 px-6 border-b border-grey-light">
                {{ stream.created_at | displayLocalDateTime }}
              </td>
              <td class="py-4 px-6 border-b border-grey-light">
                <div class="flex flex-row">
                  <button class="bg-blue-700 px-2 py-1 text-white text-sm rounded ml-2 focus:outline-none"
                    v-on:click="viewApproveStreamSaleModal(stream)">
                    View
                  </button>
                  <button class="bg-red-700 px-2 py-1 text-white text-sm rounded ml-2 focus:outline-none"
                    v-on:click="removeStreamSale(stream.id)">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          </template>
        </CustomTable>
      </template>
    </Card>

    <Card class="w-full mb-6 mx-3">
      <template v-slot:header>
        <span>
          Occuring Stream Sales
        </span>
      </template>
      <template v-slot:body>
        <CustomTable class="shadow-md mb-4">
          <template v-slot:header>
            <th
              class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">
              Owner
            </th>
            <th
              class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">
              Network
            </th>
            <th
              class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">
              Puchasing User
            </th>
            <th
              class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">
              Purchase At
            </th>
            <th
              class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">
              Invoice ID
            </th>
            <th
              class="py-4 px-6 bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light">
              Pricing (Actual/Stringer)
            </th>
            <th class="bg-grey-lightest font-bold uppercase text-sm text-grey-dark border-b border-grey-light"></th>
          </template>
          <template v-slot:body>
            <tr class="hover:bg-grey-lighter" v-for="stream in occurringSales">
              <td class="py-4 px-6 border-b border-grey-light">
                {{ stream.owner.name }}
              </td>
              <td class="py-4 px-6 border-b border-grey-light">
                {{ stream.network.name }}
              </td>
              <td class="py-4 px-6 border-b border-grey-light">
                {{ stream.purchaser.name }}
              </td>
              <td class="py-4 px-6 border-b border-grey-light">
                {{ stream.created_at | displayLocalDateTime }}
              </td>
              <td class="py-4 px-6 border-b border-grey-light">
                {{ stream.invoice_number }}
              </td>
              <td class="py-4 px-6 border-b border-grey-light">
                ${{ stream.price }}/${{ stream.stringer_cut }}
              </td>
              <td class="py-4 px-6 border-b border-grey-light">
                <button class="bg-green-700 px-2 py-1 text-white text-sm rounded ml-2 focus:outline-none"
                  v-on:click="finalizeStreamSale(stream)">
                  Finalize
                </button>
              </td>
            </tr>
          </template>
        </CustomTable>
      </template>
    </Card>
    <approve-stream-sale-modal></approve-stream-sale-modal>
  </div>
</template>

<script>
import { EventBus } from "@/utils/events";
import * as Config from "@/config";
import { mapState, mapGetters } from "vuex";
import moment from "moment";

import ApproveStreamSaleModal from "@/components/admin/modals/ApproveStreamSaleModal";
import CustomTable from "@/components/general/CustomTable";
import Card from "@/components/partials/Card";

export default {
  name: "StreamSalesPage",
  data() {
    return {
      pendingSales: [],
      occurringSales: []
    };
  },
  components: {
    "approve-stream-sale-modal": ApproveStreamSaleModal,
    CustomTable,
    Card
  },
  mounted() {
    this.getPendingStreamSales();
    this.getOccurringStreamSales();

    this.$nextTick(
      function () {
        EventBus.$on(
          "admin-approve-stream-sale-refresh-data",
          this.getPendingStreamSales
        );
      }.bind(this)
    );
  },
  methods: {
    ...mapGetters(["getAuthorizationHeader"]),
    getPendingStreamSales() {
      this.$http
        .get(
          Config.apiPath + "/api/v2/admin/stream_sales?status=pending",
          this.getAuthorizationHeader()
        )
        .then(response => {
          this.$set(this, "pendingSales", response.data);
        });
    },
    getOccurringStreamSales() {
      this.$http
        .get(
          Config.apiPath + "/api/v2/admin/stream_sales?status=occurring",
          this.getAuthorizationHeader()
        )
        .then(response => {
          this.$set(this, "occurringSales", response.data);
        });
    },
    viewApproveStreamSaleModal(data) {
      EventBus.$emit("admin-approve-stream-sale-open-modal", data);
    },
    removeStreamSale(id) {
      this.$swal({
        title: "Verify",
        text:
          "Are you sure you want to remove the sale? This action is not reversible.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it."
      }).then(result => {
        if (result.value) {
          var _this = this;
          this.$http
            .post(
              Config.apiPath + "/api/v2/admin/stream_sales/delete",
              {
                id: id
              },
              this.getAuthorizationHeader()
            )
            .then(response => {
              _this.$swal(
                "Deleted!",
                "The selected sales have been removed from the system!",
                "success"
              );
              _this.getPendingStreamSales();
            });
        }
      });
    },
    finalizeStreamSale(stream) {
      var _this = this;
      this.$swal({
        title: "Finalize sale?",
        text:
          "Finalizing this sale will mark this sale as complete, and notify the user that payment is on it's way.",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, finalize sale!"
      }).then(result => {
        if (result.value) {
          var data = {
            id: stream.id
          };

          // send mail
          _this.$http
            .post(
              Config.apiPath + "/api/v2/admin/stream_sales/finalize",
              data,
              _this.getAuthorizationHeader()
            )
            .then(response => {
              _this.$swal(
                "Complete!",
                "The sale has been marked as complete.",
                "success"
              );

              stream.status = "complete";
              _this.getOccurringStreamSales();
            });
        }
      });
    },
    openAddUsersModal() {
      this.$eventBus.$emit("admin-add-user-open-modal");
    }
  },
  filters: {
    timeAgo: function (date) {
      return moment.utc(date).fromNow();
    },
    displayLocalDateTime: function (data) {
      return moment
        .utc(data)
        .local()
        .format("MM/DD/YY h:mm a");
    }
  }
};
</script>

<style scoped>

</style>
